var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.h5sdk},[_c('iframe',{class:_vm.$style.gameFrame,attrs:{"name":"gameFrame","src":_vm.userState.game_url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }